/**
 * AlertaCarga
 * @author Simpli CLI generator
 */
import {$, Helper, Request, Resource} from 'simpli-web-sdk'
import {ResponseSerialize} from 'simpli-web-sdk'
import {Alerta} from '@/model/resource/Alerta'
import {Carga} from '@/model/resource/Carga'
import {Motorista} from '@/model/resource/Motorista'
import {AlertaCargaCollection} from '@/model/collection/AlertaCargaCollection'

/* TODO: review generated class */
export class AlertaCarga extends Resource {
  idAlertaCargaPk: number = 0

  @ResponseSerialize(Alerta)
  alerta: Alerta | null = null

  @ResponseSerialize(Carga)
  carga: Carga | null = null

  @ResponseSerialize(Motorista)
  motorista: Motorista | null = null

  dataAlerta: string | null = null

  get $id() {
    return this.idAlertaCargaPk
  }
  set $id(val) {
    this.idAlertaCargaPk = val
  }

  get idMotoristaFk() {
    if (!this.motorista) return 0
    return this.motorista.$id
  }
  set idMotoristaFk(val) {
    if (!this.motorista) this.motorista = new Motorista()
    this.motorista.$id = val
  }

  get idCargaFk() {
    if (!this.carga) return 0
    return this.carga.$id
  }
  set idCargaFk(val) {
    if (!this.carga) this.carga = new Carga()
    this.carga.$id = val
  }

  get idAlertaFk() {
    if (!this.alerta) return 0
    return this.alerta.$id
  }
  set idAlertaFk(val) {
    if (!this.alerta) this.alerta = new Alerta()
    this.alerta.$id = val
  }

  /**
   * Gets a instance of a given ID of AlertaCarga
   */
  async getAlertaCarga(id: number) {
    return await Request.get(`/admin/alerta-carga/${id}`)
      .name('getAlertaCarga')
      .as(this)
      .getData()
  }

  /**
   * Lists the instances of AlertaCarga
   */
  static async listAlertaCarga(params: any) {
    return await Request.get(`/admin/alerta-carga`, {params})
      .name('listAlertaCarga')
      .as(AlertaCargaCollection)
      .getData()
  }

  /**
   * Persists a new instance of AlertaCarga. Use ID = 0 to create a new one,
   * or ID > 0 to update a current one
   */
  async persistAlertaCarga() {
    return await Request.post(`/admin/alerta-carga`, this)
      .name('persistAlertaCarga')
      .asNumber()
      .getData()
  }

  /**
   * Lists the instances of AlertaCarga to use it in a CSV file
   */
  static async listCsvAlertaCarga(params: any) {
    return await Request.get(`/admin/alerta-carga/csv`, {params})
      .name('listCsvAlertaCarga')
      .as(AlertaCargaCollection)
      .getData()
  }
}
